import { types } from 'mobx-state-tree';

export const Technique = types.model('Technique', {
  _id:   types.optional(types.string,''),
  order:   types.number,
  humanReadableId: types.maybeNull(types.string),
  name:   types.optional(types.string,''),
  description:  types.optional(types.string,''),
  color:  types.optional(types.string,''),
  image:  types.maybeNull(types.string),
  durations: types.optional(types.array(types.number), []),
});
